import { utils } from 'ui-common';

import { getWindow } from './globalWrappers';

export function isHELOC(loanType?: string): boolean {
  return loanType === 'HELOC';
}

export function getSelectedProductId(): string | undefined {
  const cookieValue = utils.cookieUtils.get('selectedProductId');

  return cookieValue === getWindow().SHARED_CONSTANTS.CHOOSE_APPLICATION_COOKIE_VALUE ? undefined : cookieValue;
}
